
// import TaskView from "./task-view/task-view";
// import CollectionProto from "../../data-structures/depricated/collection-proto";
//
// // daz ne znau chto s etim poka delat'... poka ostavlu etu i eche odnu sdelau
// // po idee konechno tol'ko odna nuzna i model tol'ko odin nuzen ?
// // no stremno seichas trogat
//
// export default class TasksCollection extends CollectionProto<TaskView> {
//     constructor(models:any) {
//         super(models, TaskView);
//     }
// }


import Collection from "../../data-structures/collection";
import Resources from "../../resources/resources";
import Event from "./event"

export default class EventsCollection extends Collection<Event> {

    constructor(models:any) {
        super(models);
    }

    static initFromResources(resources: Resources):EventsCollection {
        return new EventsCollection(resources.events?.models)
    }

    static initFromJson(data: any): EventsCollection{
        const models : Event[]   = []

        _.map(data, (record:any)=>{
            models.push(new Event(record))
        })

        return new EventsCollection(models);
    }

    // for Glist support
    public get items():any[] {
        return this.models
    }

    // public search():TasksCollection {
    //     // need implementation
    //     return this
    // }
    //
    // public filter():TasksCollection {
    //     // need implementation
    //     return this
    // }
    //
    // public sort():TasksCollection {
    //     // need implementation
    //     return this
    // }
    //
    // public groupBy(field:FieldProto, sortDirection:SortDirection=SortDirection.ASC):GroupedData {
    //     const groups: GroupedData = groupByOperator(this.models, field, sortDirection) as GroupedData
    //     return groups
    // }
}